import { type SxProps } from '@mui/material/styles';

export const styles = {
  sidebar: {
    position: 'fixed',
    top: 0,
    left: 0,
    width: '240px',
    height: '100vh',
    backgroundColor: '#ffffff',
    borderRight: '1px solid #e5e7eb',
    display: 'flex',
    flexDirection: 'column',
    zIndex: 1000,
  },
  logoContainer: {
    display: 'flex',
    alignItems: 'center',
    gap: '8px',
    padding: '24px',
    height: '64px',
  },
  logoText: {
    fontSize: '16px',
    fontWeight: 400,
    lineHeight: '24px',
    letterSpacing: '-0.3125px',
    color: '#111827',
  },
  logoPlaceholder: {
    width: '24px',
    height: '24px',
  },
  navigation: {
    padding: '12px',
    flexGrow: 1,
    display: 'flex',
    flexDirection: 'column',
    gap: '4px',
    overflowY: 'auto',
  },
  sectionHeader: {
    fontSize: '11px',
    fontWeight: 600,
    textTransform: 'uppercase',
    letterSpacing: '0.5px',
    color: '#9ca3af',
    paddingLeft: '12px',
    paddingTop: '16px',
    paddingBottom: '8px',
  },
  sectionHeaderFirst: {
    paddingTop: '4px',
  },
  sectionItems: {
    display: 'flex',
    flexDirection: 'column',
    gap: '4px',
  },
  navButton: {
    justifyContent: 'flex-start',
    textTransform: 'none',
    height: '36px',
    borderRadius: '8px',
    paddingLeft: '12px',
    paddingRight: 0,
    fontSize: '14px',
    fontWeight: 400,
    lineHeight: '20px',
    letterSpacing: '-0.1504px',
    color: '#6b7280',
    '&:hover': {
      backgroundColor: '#f3f4f6',
    },
  },
  navButtonActive: {
    backgroundColor: '#f3f4f6',
    color: '#111827',
    '&:hover': {
      backgroundColor: '#f3f4f6',
    },
  },
  icon: {
    width: '16px',
    height: '16px',
    marginRight: '8px',
  },
  footer: {
    borderTop: '1px solid #e5e7eb',
    padding: '12px 12px',
    height: '66px',
  },
  signOutButton: {
    justifyContent: 'flex-start',
    textTransform: 'none',
    height: '36px',
    borderRadius: '8px',
    paddingLeft: '12px',
    fontSize: '14px',
    fontWeight: 500,
    lineHeight: '20px',
    letterSpacing: '-0.1504px',
    color: '#6b7280',
    '&:hover': {
      backgroundColor: '#f3f4f6',
    },
  },
} satisfies Record<string, SxProps>;
